export default __webpack_public_path__ + "static/media/brave_zone_logo.e91ec03e.svg";